<app-menu>
  <!-- <ng-container *ngIf="isCustomDetailsOpen">
    <app-contact-details
    (tabSelectionChange)="handleTabSelectionChange($event)"></app-contact-details>
  </ng-container> -->
  <!-- TO DO: set initialState once there's a default state for this grid -->
  <ag-grid-angular #agGrid
    style="width: 100%; height: 100%;"
    class="ag-theme-alpine"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [animateRows]="true"
    [rowModelType]="'serverSide'"
    [cacheBlockSize]="100"
    [maxBlocksInCache]="10"
    [masterDetail]="true"
    [detailRowHeight]="detailRowHeight"
    [detailCellRenderer]="detailCellRenderer"
    #gridreference [gridOptions]="gridOptions"
    (cellEditingStopped)="onCellEditingStopped($event)"
    (gridReady)="onGridReady($event)"
    (stateUpdated)="onStateUpdated($event)"
    [stopEditingWhenCellsLoseFocus] = "false"
  >
  </ag-grid-angular>
</app-menu>
